import { render, staticRenderFns } from "./budgetResult.vue?vue&type=template&id=2da1b144"
import script from "./budgetResult.vue?vue&type=script&lang=js"
export * from "./budgetResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da1b144')) {
      api.createRecord('2da1b144', component.options)
    } else {
      api.reload('2da1b144', component.options)
    }
    module.hot.accept("./budgetResult.vue?vue&type=template&id=2da1b144", function () {
      api.rerender('2da1b144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/budget/budgetResult.vue"
export default component.exports